import {
  QUIZ_SUBPATH,
  USER_INFO_SLUG,
  PUP_INFO_SLUG,
  BIRTHDAY_SLUG,
  BREED_SLUG,
  CALORIES_SLUG,
  ACTIVITY_SLUG,
  ALLERGIES_SLUG,
  POOP_SLUG,
  MEALPREP_SELECTION_SUBPATH,
  RECOMMENDEDPLAN_SUBPATH,
  RECIPES_SELECTION_SUBPATH,
  RECIPES_FRESH_SLUG,
  RECIPES_DRY_SLUG,
  ADDONS_SELECTION_SUBPATH,
  CHECKOUT_SUBPATH,
  CONFIRMATION_SUBPATH,
  NUTRITION_SLUG,
  ABOUT_SLUG,
  APP_CONFIRMATION_SUBPATH,
} from '../routing';

export const ROOT_SUBPATH = '/onboarding/';

export const levelToLabel = {
  Low: 'mellow',
  Moderate: 'active',
  High: 'very active',
};

export const PRODUCT_TYPES = {
  fresh: 'fresh',
  dry: 'dry',
  mixed: 'mixed',
  half_fresh: 'half_fresh',
};

export const SKU_TO_PLAN = {
  DY: PRODUCT_TYPES.dry,
  FR: PRODUCT_TYPES.fresh,
  MX: PRODUCT_TYPES.mixed,
};

export const DENTAL_CHEWS_SKUS = [
  'SUPP-DENT-XS',
  'SUPP-DENT-SM',
  'SUPP-DENT-MD',
  'SUPP-DENT-LG',
];

export const PLAN_TO_SKU = {
  dry: 'DY',
  fresh: 'FR',
  mixed: 'MX',
  half_fresh: 'FR',
};

export const FRESH_PRODUCT_TYPES = [
  PRODUCT_TYPES.fresh,
  PRODUCT_TYPES.half_fresh,
];

export const STATE = {
  initial: ROOT_SUBPATH,
  userInfo: `${QUIZ_SUBPATH}/${USER_INFO_SLUG}`,
  pupInfo: `${QUIZ_SUBPATH}/${PUP_INFO_SLUG}`,
  birthday: `${QUIZ_SUBPATH}/${BIRTHDAY_SLUG}`,
  breed: `${QUIZ_SUBPATH}/${BREED_SLUG}`,
  calories: `${QUIZ_SUBPATH}/${CALORIES_SLUG}`,
  activity: `${QUIZ_SUBPATH}/${ACTIVITY_SLUG}`,
  allergies: `${QUIZ_SUBPATH}/${ALLERGIES_SLUG}`,
  poop: `${QUIZ_SUBPATH}/${POOP_SLUG}`,
  recommendedPlan: RECOMMENDEDPLAN_SUBPATH,
  planSelection: MEALPREP_SELECTION_SUBPATH,
  fresh: `${RECIPES_SELECTION_SUBPATH}/${RECIPES_FRESH_SLUG}`,
  baked: `${RECIPES_SELECTION_SUBPATH}/${RECIPES_DRY_SLUG}`,
  addons: ADDONS_SELECTION_SUBPATH,
  submitCart: 'submit',
  checkout: CHECKOUT_SUBPATH,
  confirmation: CONFIRMATION_SUBPATH,
  appConfirmation: APP_CONFIRMATION_SUBPATH,
  about: `${QUIZ_SUBPATH}/${ABOUT_SLUG}`,
  nutrition: `${QUIZ_SUBPATH}/${NUTRITION_SLUG}`,
};

export const ACTION_TYPES = {
  initialLoad: 'initialLoad',
  toUserInfo: 'toUserInfo',
  customerInfoSaved: 'customerInfoSaved',
  toPupInfo: 'toPupInfo',
  toBirthday: 'toBirthday',
  toBreed: 'toBreed',
  toCalories: 'toCalories',
  toActivity: 'toActivity',
  toAllergies: 'toAllergies',
  toPoop: 'toPoop',
  toRecommendedPlan: 'toRecommendedPlan',
  toPlanSelection: 'toPlanSelection',
  selectedPlanType: 'selectedPlanType',
  selectedFreshRecipes: 'selectedFreshRecipes',
  selectedBakedRecipes: 'selectedBakedRecipes',
  selectedRecipesWithExtras: 'selectedRecipesWithExtras',
  toAddons: 'toAddons',
  toCheckout: 'toCheckout',
  toConfirmation: 'toConfirmation',
  goBack: 'goBack',
  toAbout: 'toAbout',
  toNutrition: 'toNutrition',
};

export const ACTIONS = {
  initialLoad: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.initialLoad,
  }),
  toUserInfo: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toUserInfo,
  }),
  customerInfoSaved: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.customerInfoSaved,
  }),
  toPupInfo: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPupInfo,
  }),
  toBirthday: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toBirthday,
  }),
  toBreed: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toBreed,
  }),
  toCalories: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toCalories,
  }),
  toActivity: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toActivity,
  }),
  toAllergies: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAllergies,
  }),
  toPoop: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPoop,
  }),
  // petComplete
  toRecommendedPlan: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toRecommendedPlan,
    };
  },
  toPlanSelection: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toPlanSelection,
    };
  },
  selectedPlanType: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.selectedPlanType,
    };
  },
  selectedFreshRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedFreshRecipes,
      props,
    };
  },
  selectedBakedRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedBakedRecipes,
      props,
    };
  },
  selectedRecipesWithExtras: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedRecipesWithExtras,
      props,
    };
  },
  toAddons: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAddons,
  }),
  toCheckout: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toCheckout,
  }),
  toConfirmation: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toConfirmation,
    };
  },
  goBack: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.goBack,
    };
  },
  //Shortened Quiz Actions
  toAbout: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAbout,
  }),
  toNutrition: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toNutrition,
  }),
};

export const pathToAction = {
  [STATE.userInfo]: ACTIONS.toUserInfo,
  [STATE.pupInfo]: ACTIONS.toPupInfo,
  [STATE.birthday]: ACTIONS.toBirthday,
  [STATE.breed]: ACTIONS.toBreed,
  [STATE.calories]: ACTIONS.toCalories,
  [STATE.activity]: ACTIONS.toActivity,
  [STATE.allergies]: ACTIONS.toAllergies,
  [STATE.poop]: ACTIONS.toPoop,
  [STATE.recommendedPlan]: ACTIONS.toRecommendedPlan,
  [STATE.planSelection]: ACTIONS.toPlanSelection,
  [STATE.fresh]: ACTIONS.selectedPlanType,
  [STATE.baked]: ACTIONS.selectedPlanType,
  [STATE.submitCart]: ACTIONS.selectedFreshRecipes,
  [STATE.submitCart]: ACTIONS.selectedBakedRecipes,
  [STATE.submitCart]: ACTIONS.selectedFreshWithExtras,
  [STATE.addons]: ACTIONS.toAddons,
  [STATE.checkout]: ACTIONS.toCheckout,
  [STATE.confirmation]: ACTIONS.toConfirmation,
  [STATE.about]: ACTIONS.toAbout,
  [STATE.nutrition]: ACTIONS.toNutrition,
};

export const STATE_TO_STEP_REFERENCE = {
  [STATE.planSelection]: 0,
  [STATE.fresh]: 1,
  [STATE.baked]: 1,
  [STATE.submitCart]: 1,
  [STATE.addons]: 2,
  [STATE.checkout]: 3,
};

export const STATE_TO_STEP_REFERENCE_RECOMMENDED = {
  [STATE.userInfo]: 0,
  [STATE.recommendedPlan]: 1,
  [STATE.submitCart]: 1,
  [STATE.checkout]: 2,
};

export const unmappedStates = [STATE.initial, STATE.submitCart];

export const PLAN_SELECTION_KEY = 'PLAN_SELECTION';
